// Lojas Triângulo — JS mínimo. Sem libs. Carregado com defer.
(function () {
  'use strict';

  // Lazy-hydrate: adiciona classe .is-ready quando a home entra em viewport,
  // permitindo animações CSS sem custo antes do primeiro paint.
  var sections = document.querySelectorAll('.tri-hero,.tri-cats,.tri-products,.tri-news');
  if ('IntersectionObserver' in window && sections.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-ready'); io.unobserve(e.target); }
      });
    }, { rootMargin: '100px' });
    sections.forEach(function (s) { s.classList && io.observe(s); });
  }

  // Hidratação lazy do vídeo/embed do hero.
  // Estratégia:
  //  1) LCP fica com o poster (imagem) — nada carrega antes.
  //  2) Só ativa vídeo quando .tri-hero está próximo do viewport (IntersectionObserver)
  //     E o browser está em idle (requestIdleCallback).
  //  3) Gate por conexão: em Save-Data ou 2G/3G, nunca hidrata — poster é o único frame.
  //  4) preload='metadata' (não 'auto') para baixar só o header antes de tocar.
  function hydrateHero() {
    var hero = document.querySelector('.tri-hero');
    if (!hero) return;

    // --- Gate por conexão / preferência do usuário ---
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (conn) {
      if (conn.saveData) return;
      var et = conn.effectiveType || '';
      if (et === 'slow-2g' || et === '2g' || et === '3g') return;
    }
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    function activateVideo(v) {
      var sources = v.querySelectorAll('source[data-src]');
      if (!sources.length && !v.getAttribute('src')) return;
      sources.forEach(function (s) {
        var url = s.getAttribute('data-src');
        if (url) s.src = url;
      });
      v.preload = 'metadata';
      try { v.load(); } catch (_) {}
      var playIt = function () {
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      };
      if (v.readyState >= 2) playIt();
      else v.addEventListener('loadeddata', playIt, { once: true });
      v.addEventListener('playing', function () { hero.classList.add('tri-hero--playing'); }, { once: true });
    }
    function activateEmbed(el) {
      var src = el.getAttribute('data-src');
      if (!src) return;
      var iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.title = el.getAttribute('data-title') || '';
      iframe.loading = 'lazy';
      iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      iframe.allowFullscreen = true;
      iframe.frameBorder = '0';
      el.appendChild(iframe);
      hero.classList.add('tri-hero--playing');
    }
    var start = function () {
      hero.querySelectorAll('video[data-hero-video]').forEach(activateVideo);
      hero.querySelectorAll('[data-hero-embed]').forEach(activateEmbed);
    };
    var runIdle = function () {
      if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 3000 });
      else setTimeout(start, 800);
    };
    // Ativa só quando o hero fica próximo do viewport.
    if ('IntersectionObserver' in window) {
      var hio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { hio.disconnect(); runIdle(); }
        });
      }, { rootMargin: '200px' });
      hio.observe(hero);
    } else {
      runIdle();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateHero, { once: true });
  } else {
    hydrateHero();
  }

  // Impede duplo-submit no form da newsletter.
  var form = document.querySelector('.tri-news__form');
  if (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('button[type=submit]');
      if (btn) { btn.disabled = true; btn.textContent = 'Enviando...'; }
    });
  }
})();
